import { AbstractControl, ValidatorFn } from '@angular/forms';

export function isValidEmail(): ValidatorFn {
    const pattern = "^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$";
    return (control: AbstractControl): Record<string, unknown> | null => {
        const reg = new RegExp(pattern);
        const isEmail = reg.test(control?.value);
        if (!isEmail) {
            if (control.value === '') {
                return null;
            }

            return {
                email: { value: 'value is not a valid email' },
                req: { value: true },
            };
        }
        return null;
    };
}
